import axios from "axios";
import { Message, Dialog, Notification } from "element-ui";
// import store from "@/store";
import { removeToken } from "./auth";
import { projectFileUrl } from "@/config";
import { router } from "@/router";

// 不要直接使用axios，要创建一个实例来使用
const service = axios.create({
  baseURL: projectFileUrl, // 此项目后台管理不使用process.env.BASE_URL
  headers: {
    get: {
      "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8"
    },
    post: {
      "Content-Type": "application/json; charset=UTF-8"
    }
  },
  withCredentials: true,
  timeout: 600000 // 请求超时时间
});
let count = 0; // 请求计数
// request 拦截器
service.interceptors.request.use(
  config => {
    config.headers['locker'] = new Date().getTime() + count++; // 解决多次连续调用同一个接口，locker相同导致的接口报错
    // 是否需要设置 token
    // const isToken = (config.headers || {}).isToken === false
    // if (getToken() && !isToken) {
    //   config.headers['Authorization'] = 'Bearer ' + getToken() // 让每个请求携带自定义token 请根据实际情况自行修改
    // }
    // get请求映射params参数
    if (config.method === 'get' && config.params) {
      let url = config.url + '?';
      for (const propName of Object.keys(config.params)) {
        const value = config.params[propName];
        var part = encodeURIComponent(propName) + "=";
        if (value !== null && typeof (value) !== "undefined") {
          if (typeof value === 'object') {
            for (const key of Object.keys(value)) {
              let params = propName + '[' + key + ']';
              if (value[key]) {
                var subPart = encodeURIComponent(params) + "=";
                url += subPart + encodeURIComponent(value[key]) + "&";
              }
            }
          } else {
            url += part + encodeURIComponent(value) + "&";
          }
        }
      }
      url = url.slice(0, -1);
      config.params = {};
      config.url = url;
    }
    return config;
  },
  error => {
    Promise.reject(error);
  }
);

// response 拦截器
service.interceptors.response.use(
  response => {
    const code = response.status;
    if (code < 200 || code > 300) {
      Notification.error({
        title: response.data.message
      })
      return Promise.reject("error");
    } else {
      if (code == 200) {
        if (![200].includes(response.data.status)) {
          if (response.data.status == 4000 && response.config.url.includes("/batch/")) { // 批量特殊拦截
            return Promise.resolve(response.data);
          } else if (response.data.status == 4003) {
            removeToken();
            Message({
              message: "用户未登录或用户无权限，请重新登录",
              type: 'error',
              duration: 5000,
              showClose: true
            })
            // router.replace({
            //   path: "/login"
            // })
            location.href = process.env.BASE_URL;
          } else {
            response.data.message && Message({
              message: response.data.message,
              type: 'error',
              duration: 5000,
              showClose: true
            })
          }
        }
        return Promise.resolve(response.data);
      }
    }
  },
  error => {
    let code = 0;
    try {
      code = error.response.data.status;
    } catch (e) {
      if (error.toString().indexOf("Error: timeout") !== -1) {
        Notification.error({
          type: "danger",
          title: "网络请求超时"
        })
        return Promise.reject(error);
      }
      if (error.toString().indexOf("Error: Network Error") !== -1) {
        Notification.error({
          type: "danger",
          title: "网络请求错误"
        })
        return Promise.reject(error);
      }
    }
    if (code === 401 || code === 4003) {
      Dialog.confirm({
        title: "系统提示",
        message: "用户未登录或用户无权限，请重新登录"
      }).then(() => {
        removeToken();
        // router.replace({
        //   path: "/login"
        // })
        location.href = process.env.BASE_URL;
      });
    } else {
      const errorMsg = error.response.data.message;
      Notification.error({ type: "danger", title: "网络请求错误" });
    }
    return Promise.reject(error);
  }
);

export default service;
